module.exports = __webpack_public_path__ + "img/product17.8c0d7898.png";